import Vue from 'vue'
import { formataData, formataMoeda, formataCpf, formataCnpj, formataCpfCnpj, formataNumeroCarga, formataTelefone, calculoGris, capitalize, formataCep } from '@/assets/js/helpers'

Vue.filter('capitalize', function (value) {
  return capitalize(value)
})

Vue.filter('toUpperCase', function (value) {
  return String(value).toUpperCase()
})

Vue.filter('toLowerCase', function (value) {
  return String(value).toLowerCase()
})

Vue.filter('money', function (value, symbol = 'R$ ', decimalPlaces = 2) {
  return symbol + formataMoeda(value, decimalPlaces)
})

Vue.filter('formataMoeda', function (value, symbol = 'R$ ', decimalPlaces = 2) {
  return symbol + formataMoeda(value, decimalPlaces)
})

Vue.filter('formataData', function (value) {
  if (value) {
    return formataData(value)
  }
})

Vue.filter('formataCpf', function (value) {
  return formataCpf(value)
})

Vue.filter('formataCnpj', function (value) {
  return formataCnpj(value)
})

Vue.filter('formataCpfCnpj', function (value) {
  return formataCpfCnpj(value)
})

Vue.filter('formataNumeroCarga', function (value) {
  return formataNumeroCarga(value)
})

Vue.filter('formataTelefone', function (value) {
  return formataTelefone(value)
})

Vue.filter('calculoGris', function (value) {
  return calculoGris(value)
})

Vue.filter('formataCep', function (value) {
  return formataCep(value)
})



// WEBPACK FOOTER //
// ./src/assets/js/filters.js